import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'optionsTooltip',
})
export class OptionsTooltipPipe implements PipeTransform {
  transform(key: string, options?: AnyType[]): string {
    if (!key) {
      return key;
    }

    return this.getTooltip(key, options);
  }

  private getTooltip(key: string, options?: AnyType[]): string {
    if (options) {
      const option = options.find((o) => o._id === key || o.id === key);
      if (option) {
        return option.tooltipUser || option.tooltip;
      }
    }
    return key;
  }
}
